import { useQuery } from '@tanstack/react-query';
import { attachmentApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Signed download URL for one attachment, used to render inline previews. */
export function useAttachmentUrl(id: string | null | undefined) {
  return useQuery({
    queryKey: queryKeys.attachments.url(id ?? ''),
    queryFn: ({ signal }) =>
      attachmentApiClient.download(id!, toCancelToken(signal)),
    enabled: !!id,
    // Signed URLs expire, so they are refetched rather than reused across sessions.
    staleTime: 60_000,
    meta: { errorContext: 'attachment url' },
  });
}
